module.exports = "https://static.energy5.com/_next/static/images/ledServices-066088155184fb2d55907ed64f4a6c63.webp";